/**
 * Copy + rule for the chat composers' brand gate. Pure, so the three composer
 * surfaces (`chat-prompt-input-bar`, `launch-composer`,
 * `canvas-chat-thread`) cannot drift and the rule is testable without a DOM.
 *
 * Submission is gated on the ACTIVE brand being ready (`isActiveBrandReady`):
 * a new chat is scoped to that brand, and generating against a brand that is
 * still extracting has no design system to draw on (the orchestrator would
 * classify the first turn as an extraction run). `hasReadyBrand` only picks
 * the copy: with no ready brand anywhere the org is still in first-brand
 * setup; otherwise the user merely has an in-flight brand selected.
 */
export const COMPOSER_PLACEHOLDER_DEFAULT =
  'Describe the email you want to create...'
export const COMPOSER_PLACEHOLDER_NO_READY_BRAND =
  'Finish brand setup to start chatting...'
export const COMPOSER_PLACEHOLDER_ACTIVE_BRAND_EXTRACTING =
  'This brand is still setting up. Switch brands or wait for extraction to finish.'

export function getComposerBrandGatePlaceholder(args: {
  isActiveBrandReady: boolean
  hasReadyBrand: boolean
}): string {
  if (args.isActiveBrandReady) {
    return COMPOSER_PLACEHOLDER_DEFAULT
  }
  return args.hasReadyBrand
    ? COMPOSER_PLACEHOLDER_ACTIVE_BRAND_EXTRACTING
    : COMPOSER_PLACEHOLDER_NO_READY_BRAND
}
